import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	watchersWarningFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	watchersErrorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	watchersWarningFlagTitleIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	watchersWarningFlagTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	watchersWarningFlagTitle: {
		id: 'issue-create.modal.watchers-warning-flag-title',
		defaultMessage: 'Watchers not added to your issue',
		description: 'Title for error flag when issue is created but watchers has warning',
	},
	watchersErrorFlagTitle: {
		id: 'issue-create.modal.watchers-error-flag-title',
		defaultMessage: 'Something went wrong',
		description: 'Title for error flag when issue is created but watchers has error',
	},
	watchersWarningFlagTitleIssueTermRefresh: {
		id: 'issue-create.modal.watchers-warning-flag-title-issue-term-refresh',
		defaultMessage: 'Watchers not added to your work item',
		description: 'Title for error flag when issue is created but watchers has warning',
	},
	watchersWarningFlagTitleIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.watchers-warning-flag-title-issue-terminology-refresh-m4',
		defaultMessage: 'Watchers not added to the {issueType} {issueKey}',
		description:
			'Title for error flag when issue is created but watchers has warning. Please translate as “work type {issueType}”',
	},
});
export default messages;
